import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
const focusStyles = css `
  outline: none;
  background-color: ${theme.semantic.surface.primary};
  border-color: ${(props) => (props.$invalid ? theme.semantic.text.danger : theme.swatches.warm[400])};
  color: ${theme.semantic.foreground.secondary};
  box-shadow: 0 0 0 ${pxToRem(3)} ${(props) => (props.$invalid ? theme.swatches.red[200] : theme.swatches.warm[50])};
`;
export const Button = styled.button `
  ${interactiveTransition};
  padding: ${theme.spacing.md};
  display: flex;
  justify-content: space-between;
  align-items: center;
  appearance: none;
  min-width: ${pxToRem(200)};
  width: ${(props) => (props.$stretch ? '100%' : 'auto')};
  height: ${pxToRem(40)};
  border-radius: ${theme.borderRadius.sm};
  border: ${pxToRem(1)} solid
    ${(props) => (props.$invalid ? theme.semantic.text.danger : theme.semantic.border.default)};
  background-color: ${theme.semantic.surface.primary};
  color: ${theme.semantic.text[100]};
  font-family: inherit;
  font-size: ${theme.fontSize.small};
  line-height: ${theme.lineHeight.default};

  &:hover {
    background-color: ${theme.semantic.surface.primary};
    border-color: ${(props) => (props.$invalid ? theme.swatches.red[300] : theme.semantic.border.default)};
    color: ${theme.semantic.foreground.secondary};
    box-shadow: 0 0 0 ${pxToRem(3)} ${(props) => (props.$invalid ? theme.swatches.red[200] : theme.swatches.warm[50])};
  }

  ${(props) => props.$isFocused && focusStyles};

  &:focus-visible {
    ${focusStyles};
  }

  &:disabled {
    pointer-events: none;
    background-color: ${theme.semantic.surface.sunken};
    border-color: ${theme.semantic.border.default};
    color: ${theme.semantic.foreground.disabled};
  }

  ::placeholder {
    color: ${theme.semantic.text[100]};
    opacity: 1;
  }
`;
export const Label = styled.label `
  display: inline-block;
  font: ${theme.fontRole.label};
  color: ${theme.semantic.foreground.tertiary};
`;
export const Description = styled.div `
  font: ${theme.fontRole.bodySm};
  color: ${theme.semantic.text[100]};
`;
